import React from 'react';
import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  ModalActionRow,
  ModalCancelBtn,
  ModalConfirmBtn,
} from './leadHelpers';

interface VerifyDocumentModalProps {
  open: boolean;
  tempDoc: any;
  type: 'quotation' | 'order';
  onClose: () => void;
  onConfirm: () => void;
}

export const VerifyDocumentModal: React.FC<VerifyDocumentModalProps> = ({
  open,
  tempDoc,
  type,
  onClose,
  onConfirm,
}) => {
  if (!open || !tempDoc) return null;

  const isQuotation = type === 'quotation';
  const docNoLabel = isQuotation ? 'Quotation No' : 'Order No';
  const docNo = isQuotation ? tempDoc.quotation_no : tempDoc.order_no;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <ModalTitle>Verify {isQuotation ? 'Quotation' : 'Order'} Details</ModalTitle>
        <div style={{ fontSize: '14px', color: '#4b5563', lineHeight: '1.6', marginBottom: '20px' }}>
          <p style={{ margin: '0 0 12px 0' }}>
            Please confirm the {isQuotation ? 'quotation' : 'order'} details before sending to WhatsApp:
          </p>
          <div
            style={{
              background: '#f9fafb',
              padding: '12px 16px',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              marginBottom: '16px',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
              <span style={{ fontWeight: 600 }}>{docNoLabel}:</span>
              <span>{docNo}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
              <span style={{ fontWeight: 600 }}>Customer Name:</span>
              <span>{tempDoc.customer_name}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
              <span style={{ fontWeight: 600 }}>Customer Phone:</span>
              <span>{tempDoc.customer_phone}</span>
            </div>
            {tempDoc.grand_total !== undefined && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <span style={{ fontWeight: 600 }}>Grand Total:</span>
                <span>₹{tempDoc.grand_total}</span>
              </div>
            )}
          </div>

          {tempDoc.events && tempDoc.events.length > 0 && (
            <div>
              <h4
                style={{
                  margin: '0 0 8px 0',
                  fontSize: '13px',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  color: '#6b7280',
                }}
              >
                Event Details
              </h4>
              <div style={{ display: 'grid', gap: '8px' }}>
                {tempDoc.events.map((ev: any, i: number) => (
                  <div
                    key={i}
                    style={{
                      background: '#fff',
                      border: '1.5px solid #f3f4f6',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      fontSize: '13px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontFamily: "'Urbanist', sans-serif"
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>
                      {ev.event_type_name || ev.event_type || 'Event'}
                    </span>
                    <span style={{ color: '#4b5563' }}>
                      {ev.event_date || 'No Date'} {ev.event_time ? `(${ev.event_time})` : ''}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <ModalActionRow>
          <ModalCancelBtn onClick={onClose}>Cancel</ModalCancelBtn>
          <ModalConfirmBtn onClick={onConfirm}>Confirm & Send</ModalConfirmBtn>
        </ModalActionRow>
      </ModalContent>
    </ModalOverlay>
  );
};
